<template>
  <v-app data-rtls-product-root>
    <!-- 400 is the default font weight if no weight is specified, 600 is used for bold -->
    <link
      href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600&display=swap"
      rel="stylesheet"
    />
    <link
      href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Round"
      rel="stylesheet"
    />
    <link
      href="https://cdn.jsdelivr.net/npm/@mdi/font@7.x/css/materialdesignicons.min.css"
      rel="stylesheet"
    />
    <!-- TODO remove FA -->
    <link
      href="https://cdn.jsdelivr.net/npm/font-awesome@4.x/css/font-awesome.min.css"
      rel="stylesheet"
    />
    <MainNavbar v-if="!hideNavbar" />
    <ChristmasSnow />
    <v-main>
      <!-- TODO Remove this once AOV3-8139 is done -->
      <v-container :key="appKey" class="main-container pa-0" fluid>
        <router-view #default="{ Component }" class="main-page">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </v-container>
    </v-main>
    <!-- AI Side Panel - overlay (default) or pinned mode that pushes content.
         Hidden when embedded: the shell owns the single assistant and AO contributes context and
         actions to it over the platform bridge - ADR-012 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/012-ai-assistant-extraction.md
    -->
    <AiSidePanel v-if="!hideNavbar && !embedded" />
    <!-- {{ /* AOV3-823 TODO: better handling for multiple notifications? possibly display stack of snackbars? */ }} -->
    <MainSnackbar />
    <MainAlert />
    <ConnectionSnackbar />
    <MainFooter v-if="!embedded" />
    <div id="consent_blackbar" />
  </v-app>
</template>

<script>
import { find, get } from 'lodash';
import { useFeature } from '@/composables/use-feature';
import { useContextStore } from '@/stores/context';
import { isEmbedded } from '@/webshell-embed/embedded';
import { mapState } from 'pinia';
import AiSidePanel from '@/components/AiSidePanel.vue';

export default {
  components: {
    AiSidePanel,
  },

  data() {
    return {
      notificationColours: {
        starting: 'info',
        finished: 'success',
        failed: 'error',
      },
    };
  },

  computed: {
    ...mapState(useContextStore, ['appKey']),
    topLevelRoute() {
      const topLevelNavPath = get(this, '$route.matched.0.path');
      return find(this.$router.options.routes, { path: topLevelNavPath }) || {};
    },

    hideNavbar() {
      // Embedded, the shell owns the chrome.
      if (this.embedded) return true;
      if (!this.topLevelRoute.meta) return false;
      return this.topLevelRoute.meta.hideNavbar;
    },

    embedded() {
      return isEmbedded();
    },
  },

  mounted() {
    const { showStrictlyNecessaryCookiesNotice } = useFeature();
    if (!showStrictlyNecessaryCookiesNotice.value) return;

    const cookieScript = document.createElement('script');
    cookieScript.setAttribute('async', 'async');
    cookieScript.setAttribute('crossorigin', 'crossorigin');
    cookieScript.setAttribute(
      'src',
      '//cmp.osano.com/16CFuWSuPfE35eNP/9e220dc6-b4e9-4b7d-8de4-9aa0e81a60b0/osano.js'
    );
    document.body.appendChild(cookieScript);
  },
};
</script>

<style lang="scss">
@import '@style/base/_variables.scss';
html {
  position: relative;
  min-height: 100%;
}

.main-container {
  height: 100%;
  padding-bottom: 1px !important;
  padding-top: 20px !important;
}
.main-page {
  height: 100%;
  padding-bottom: $page-padding-bottom;
}
</style>
